<template>
  <div id="login" class="text-left">
    <b-container id="loginForm" v-if="!signedIn">
      <b-row>
        <b-col class="text-center">
          <b-alert variant="warning" :show="inError" style="display:inline-block;">
            {{ loginErrorMessage }}
          </b-alert>
        </b-col>
      </b-row>
      <b-form @submit="onSubmit">
        <b-form-group id="userGroup" label="User Name:" label-for="userInput">
          <b-form-input id="userInput" type="text" v-model="form.user" required
                        placeholder="Apop user name or email address"/>
        </b-form-group>

        <b-form-group id="passGroup" label="Password:" label-for="passInput">
          <b-form-input id="passInput" type="password" v-model="form.pass" required/>
          <a href="#" @click="$router.push('/forgotpassword')" class="forgotLink">Forgot Password?</a>
        </b-form-group>

        <b-button class="mr-2" type="submit" variant="outline-danger">Submit</b-button>
        <b-button type="reset" variant="outline-danger">Reset</b-button>

      </b-form>
    </b-container>
  </div>
</template>

<script>
  import { Auth } from 'aws-amplify'
  import { AmplifyEventBus } from 'aws-amplify-vue'

  export default {
    name: 'Login',
    data () {
      return {
        inError: false,
        loginErrorMessage: '',
        form: {
          user: '',
          pass: ''
        },
      }
    },
    props: {},
    created () {
      this.findUser()
      AmplifyEventBus.$on('authState', info => {
        if (info === 'signedIn') {
          this.findUser()
        } else {
          this.$store.dispatch('completeSignOut')
        }
      })
    },
    computed: {
      signedIn () {
        return this.$store.state.signedIn
      }
    },
    methods: {
      onSubmit (e) {
        e.preventDefault()
        this.inError = false
        Auth.signIn(this.form.user, this.form.pass)
          .then(user => {
            this.$store.dispatch('updateSignedInUser', user)
            this.$router.push('dashboard')
          })
          .catch(err => {
            if (err.code === 'UserNotConfirmedException') {
              this.$router.push('unconfirmed')
            } else {
              this.loginErrorMessage = err.message
              this.inError = true
            }
          })
      },
      async findUser () {
        try {
          const user = await Auth.currentAuthenticatedUser()
          await this.$store.dispatch('updateSignedInUser', user)
        } catch (err) {
          await this.$store.dispatch('completeSignOut')
        }
      }
    }
  }
</script>

<style scoped>

  #loginForm {
    color: burlywood;
    width: 50%;
  }

  .forgotLink {
    font-size: 85%;
  }

</style>
